var Reverb = window.Reverb || {};

Reverb.StickyHeader = (function StickyHeader() {
  function isNarrowViewport() {
    return window.innerWidth <= 640;
  }

  function toggleDataAttribute(dir) {
    document.body.setAttribute(
      'data-sticky-header-active',
      dir
    );
  }

  function padForStickyHeader() {
    var headerHeight = $('.site-header').outerHeight();
    var offsetPadding = -(20 + headerHeight);

    if (isNarrowViewport()) {
      toggleDataAttribute(false);
      headerHeight = 0;
      offsetPadding = 0;
    } else {
      toggleDataAttribute(true);
    }

    $('.body-wrapper').css('padding-top', headerHeight + 'px');
    $('.offset-anchor').css('top', offsetPadding + 'px');

    // due to video page's unique layout logic
    $('[data-youtube-api="video-header"]').css('top', headerHeight + 'px');
  }

  function init() {
    $(window).on('scroll resize', padForStickyHeader);
    padForStickyHeader();
  }

  return {
    init: init
  };
}());

$(Reverb.StickyHeader.init);



// WEBPACK FOOTER //
// ./javascripts/components/legacy/sticky_header.js